import { ReactNode } from 'react';

import startCase from 'lodash/startCase';
import toLower from 'lodash/toLower';

import { cn } from '@/utils/tailwind';

import DocumentHead from '@/components/document/DocumentHead';

interface PageTitleProps {
  className?: string;
  dataTestId?: string;
  children?: ReactNode;
}

const PageTitle: React.FC<PageTitleProps> = ({
  className,
  dataTestId,
  children,
}) => (
  <div
    className={cn('flex w-full flex-col items-start', className)}
    data-testid={dataTestId}
  >
    {children && (
      <>
        <DocumentHead pageTitle={startCase(toLower(children as string))} />
        <p className="text-grayscale-gray6 dark:text-contrast text-2xl font-bold">
          {children}
        </p>
      </>
    )}
  </div>
);

export default PageTitle;
